import { Box, Button, Switch, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import style from "../RegListActionCard.module.css";
import FormInputMSPerson from "../../../Inputs/FormInputMSPerson";
import FormInputSwitch from "../../../Inputs/FormInputSwitch";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";

const RegisterUser = ({ show, registerUser, joinWaitlist, workshopIsFull }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { attendees: null, sendMail: true, addEvent: false },
    criteriaMode: "all",
    mode: "onChange",
  });

  const onSubmit = (data) => {
    //if the workshop is full add the user to the waitlist
    workshopIsFull
      ? joinWaitlist(data.attendees[0], data.sendMail)
      : registerUser(data.attendees[0], data.sendMail, data.addEvent);
    reset();
  };

  const onError = (data) => {
    console.log("error ", data);
  };

  return (
    <Box className={`${style.container} ${!show && style.hidden}`}>
      <form>
        <Typography variant="h5">Register on behalf of a user</Typography>
        <FormInputMSPerson
          name="attendees"
          label="Add attendee"
          control={control}
          rules={{
            required: {
              value: true,
              message: "Select a person to add",
            },
          }}
          error={errors.attendees?.message}
        />

        <Box className={style.section}>
          <Typography variant="body1">
            Add information to user's Outlook
          </Typography>
          <Box sx={{ display: "flex" }}>
            <Box>
              <FormInputSwitch
                name="sendMail"
                label="Send email"
                control={control}
              />
            </Box>
            {!workshopIsFull && (
              <Box>
                <FormInputSwitch
                  name="addEvent"
                  label="Add to calendar"
                  control={control}
                />
              </Box>
            )}
          </Box>
        </Box>
        {workshopIsFull && (
          <Box
            sx={{
              padding: "0.5rem",
            }}
          >
            <Typography
              variant="body1"
              color="primary"
              fontWeight="bold"
              sx={{ display: "flex", alignItems: "center" }}
            >
              The workshop is full
            </Typography>
          </Box>
        )}
        <Button
          variant="contained"
          onClick={(e) =>
            handleSubmit(
              onSubmit,
              onError
            )(e).catch((e) => {
              console.log("e", e);
            })
          }
          startIcon={
            workshopIsFull ? <AccessTimeIcon /> : <PersonAddAlt1Icon />
          }
        >
          {workshopIsFull ? "Add user to waitlist" : "Register selected user"}
        </Button>
      </form>
    </Box>
  );
};

export default RegisterUser;
